import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

function normalizeAxiosError(e) {
    return e?.response?.data?.error || e?.message || "Unbekannter Fehler";
}

export default function useCuisines() {
    const [cuisines, setCuisines] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchCuisines = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const res = await axios.get(`${API_BASE}/api/cuisines`, { withCredentials: true });
            const data = res.data?.cuisines ?? res.data ?? [];
            setCuisines(Array.isArray(data) ? data : []);
        } catch (e) {
            setError(normalizeAxiosError(e));
        } finally {
            setLoading(false);
        }
    }, []);

    const createCuisine = useCallback(async (payload) => {
        try {
            const res = await axios.post(`${API_BASE}/api/cuisines`, payload, { withCredentials: true });
            await fetchCuisines();
            return res.data?.cuisine;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchCuisines]);

    const updateCuisine = useCallback(async (id, payload) => {
        try {
            const res = await axios.put(`${API_BASE}/api/cuisines/${id}`, payload, { withCredentials: true });
            await fetchCuisines();
            return res.data?.cuisine;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchCuisines]);

    const deleteCuisine = useCallback(async (id) => {
        try {
            await axios.delete(`${API_BASE}/api/cuisines/${id}`, { withCredentials: true });
            await fetchCuisines();
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchCuisines]);

    useEffect(() => {
        fetchCuisines();
    }, [fetchCuisines]);

    return {
        cuisines,
        loading,
        error,
        fetchCuisines,
        createCuisine,
        updateCuisine,
        deleteCuisine,
    };
}
